export default {"src":"/_next/static/media/CollectionIconCategoryActive.b17e6c87.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};